import { IndicatorResponseDto } from '../dto/response/indicator-response.dto';
import { IndicatorSaveRequestDto } from '../dto/request/indicator-save-request.dto';
import { IndicatorUpdateRequestDto } from '../dto/request/indicator-update-request.dto';
import { BaseLandscapeService } from '../../base-landscape.service';
import {
  getLanguageKey,
  LocalesLanguagesConstants,
} from '../../../../locales/locales';

class IndicatorService extends BaseLandscapeService {
  public async fetchIndicators(): Promise<IndicatorResponseDto[]> {
    const response = await this.get<IndicatorResponseDto[]>(`/indicator`);
    return response.data;
  }

  public async fetchIndicatorById(
    id: string,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<IndicatorResponseDto> {
    const response = await this.get<IndicatorResponseDto>(`/indicator/${id}`, {
      headers: {
        'accept-language': getLanguageKey(language),
      },
    });
    return response.data;
  }

  public async saveIndicator(
    saveRequest: IndicatorSaveRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<IndicatorResponseDto> {
    const response = await this.post<IndicatorResponseDto>(
      `/indicator`,
      saveRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async updateIndicator(
    updateRequest: IndicatorUpdateRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<IndicatorResponseDto> {
    const response = await this.put<IndicatorResponseDto>(
      `/indicator`,
      updateRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async deleteIndicator(
    existingId: string,
    compactId: string | null = null
  ): Promise<void> {
    await this.delete<void>(`/indicator/${existingId}`, {
      params: {
        compactId,
      },
    });
  }
}

const indicatorService = new IndicatorService();
export default indicatorService;
